import { Col, Row, notification, Form, Switch, Transfer, Slider } from "antd";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { TransferItem } from "node_modules/antd/lib/transfer/index";
import { useContext, useEffect, useState } from "src/ReactTS";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { FormComponentProps } from "antd/lib/form";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import Title from "src/components/common/Title";
import { UserType } from "src/services/interfaces/UserInterface";
import { PbrInputCpf } from "src/components/common/PbrInputCpf/PbrInputCpf";
import { PbrInputPhone } from "src/components/common/PbrInputPhone/PbrInputPhone";
import { PbrInputEmail } from "src/components/common/PbrInputEmail/PbrInputEmail";
import { AuthContext } from "src/components/context/AuthContext";
import { IOfficerDto } from "src/services/interfaces/AdminInterfaces";
import { ServiceContext } from "src/services/provider/Service.provider";
import FormItem from "antd/lib/form/FormItem";

function UserEdit(props: RouteComponentProps<any> & FormComponentProps) {
  const { userService } = useContext(ServiceContext);
  const { currentUser } = useContext(AuthContext);
  const [type, setType] = useState<UserType>(undefined);
  const [officerId, setOfficerId] = useState<number>(undefined);
  const [officerCommission, setOfficerCommission] = useState<number>(undefined);
  const [officerLogoFileKey, setOfficerLogoFileKey] = useState<string>("");
  const [officerType, setOfficerType] = useState<string>("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [fullName, setFullName] = useState("");
  const [login, setLogin] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [commission, setCommission] = useState(0);
  const [active, setActive] = useState(true);
  const [id, setId] = useState<number>(0);
  const [officers, setOfficers] = useState<IOfficerDto[]>([]);
  const [officerName, setOfficerName] = useState<string>("");
  const [profileList, setProfileList] = useState<any[]>([]);
  const [profileTransferList, setProfileTransferList] = useState<any[]>([]);
  const [profileKeysList, setProfileKeysList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [refreshScreen, setRefreshScreen] = useState<boolean>(false);
  const [isEditDisallowed, setIsEditDisallowed] = useState<boolean>(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      if (!errs && !isEditDisallowed) {
        setLoading(true);
        const data: any = {
          id,
          login,
          cpfCnpj,
          fullName,
          active,
          phoneNumber,
          type,
          officerCommission: commission,
          officer: {
            id: officerId,
            name: officerName,
            commission: officerCommission,
            logoFileKey: officerLogoFileKey,
            type: officerType
          },
          profiles: profileList.filter(element => profileKeysList.findIndex(e1 => e1 === element.id.toString()) !== -1)
        };

        userService
          .postCreate(data)
          .then(res => {
            if (isNew) {
              try {
                // authContext.inviteUser(login);
                notification.success({
                  description: "Usuário salvo com sucesso!",
                  message: "Registro salvo com sucesso"
                });
              } catch (error) {
                console.error("ERROR 1", error);
                notification.error({
                  message: "Falha ao enviar convite",
                  description: "Não foi possível enviar o convite ao usuário."
                });
              }
            }

            notification.success({
              description: "Usuário salvo com sucesso!",
              message: "Registro salvo com sucesso"
            });
            console.error("ERROR 2");
          })
          .catch(err => {
            notification.error({
              description: "Não foi possível salvar os dados informados.",
              message: "Erro ao salvar as informações "
            });
            console.error("ERROR 3");
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
            window.scrollTo(0, 0);
            setTimeout(function () {
              setRefreshScreen(true);
            }, 1500);
          });
      }
    });
  }

  useEffect(() => {
    const idParam = props.match.params.id;
    setType(currentUser.type);
    setOfficerId(currentUser.officer ? currentUser.officer.id : null);
    setOfficerCommission(currentUser.officer ? currentUser.officer.commission : null);
    setOfficerLogoFileKey(currentUser.officer ? currentUser.officer.logoFileKey : null);
    setOfficerName(currentUser.officer ? currentUser.officer.name : null);
    setOfficerType(currentUser.officer ? currentUser.officer.type : null);
    setLoading(true);

    try {
      userService.getProfiles().then(values => {
        setProfileList(values);
        setProfileTransferList(
          values.map(element => {
            const profileTransferItemObj: TransferItem = { key: "", title: "" };
            // profileTransferItemObj.title = IUser.OfficerProfilesAlias[element.name];
            profileTransferItemObj.title = element.name;
            profileTransferItemObj.key = element.id.toString();
            return profileTransferItemObj;
          })
        );
      });
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }

    if (idParam && idParam !== "new") {
      userService.getById(idParam).then(res => {
        res.profiles.map(e => {
          if (e.name === "Officer_Master" || currentUser.login === res.login) {
            setIsEditDisallowed(true);
          }
        });
        setId(idParam);
        setFullName(res.fullName);
        setCpfCnpj(res.cpfCnpj);
        setLogin(res.login);
        setActive(res.active);
        setPhoneNumber(res.phoneNumber);
        setCommission(res.officerCommission);
        setProfileKeysList(res.profiles.map(element => element.id.toString()));
      });
    } else if (idParam === "new") {
      setIsNew(true);
      setIsEditDisallowed(true);
    }
  }, [refreshScreen]);

  useEffect(() => {
    if (type === UserType.Officer && officers.length === 0) {
      userService
        .getAll()
        .then(res => {
          setOfficers(res);
        })
        .catch(err => {
          console.log(err);
          notification.error({
            description: "Não foi possível carregar a lista de officers.",
            message: "Erro ao obter informações "
          });
        });
    }
  }, [type]);

  const handleProfileTransferChange = targetKeys => {
    setProfileKeysList(targetKeys);
  };

  return (
    <div className="bank-info" style={{ paddingLeft: '2rem' }}>
      <Title size="h3" preset="bolder">
        Cadastro de Usuário
      </Title>
      <PbrSeparator />

      <div>
        <Form onSubmit={e => handleSubmit(e)}>
          <Title style={{ marginBottom: "27px" }} preset="bolder" size={"h4"}>
            Dados gerais
          </Title>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Switch checkedChildren="Ativo" unCheckedChildren="Inativo" checked={active} onChange={e => setActive(e)} />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <PbrInput
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                name="name"
                title="Nome"
                formItemProps={{ label: "Nome" }}
                placeholder="Digite o nome do usuário"
                formWrapper={props.form}
                rules={[
                  {
                    required: true,
                    message: "Informe o Nome do usuário."
                  }
                ]}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <PbrInputCpf
                formWrapper={props.form}
                name={"cpf"}
                value={cpfCnpj}
                title="CPF"
                formItemProps={{ label: "CPF/CNPJ" }}
                onChange={e => setCpfCnpj(e.target.value)}
                rules={[
                  {
                    required: true,
                    message: "Informe o CPF/CNPJ"
                  }
                ]}
              />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <PbrInputPhone
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
                name="phone"
                title="Celular"
                formItemProps={{ label: "Celular" }}
                formWrapper={props.form}
                rules={[
                  {
                    required: true,
                    message: "Informe o Número do Telefone"
                  }
                ]}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <PbrInputEmail
                name="email"
                formWrapper={props.form}
                value={login}
                onChange={e => setLogin(e.target.value)}
                rules={[
                  {
                    required: true,
                    message: "Informe o E-mail."
                  }
                ]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12}>
              <FormItem colon={false} className="pbr-form-item" label="Comissão" required>
                <Slider
                  min={0}
                  max={100}
                  value={commission * 100}
                  onChange={(value: number) => setCommission(value / 100)}
                  step={0.01}
                />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <PbrSeparator />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Title size="h4" preset="bolder">
                Perfis
              </Title>
              <Transfer
                dataSource={profileTransferList}
                listStyle={{
                  width: "47%",
                  height: 300
                }}
                showSearch
                targetKeys={profileKeysList}
                onChange={e => handleProfileTransferChange(e)}
                render={item => item.title}
              />
              <PbrSeparator />
            </Col>
          </Row>
          {/* <Row gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <PbrSelect name="type" size="large" formItemProps={{ label: "Tipo Usuário" }} formWrapper={props.form} showSearch value={UserType.Officer} disabled={true}>
                <Option key={"Officer"} value={"Officer"}>
                  Officer
                </Option>
              </PbrSelect>
            </Col>
            {type === UserType.Officer && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <PbrSelect name="officer" size="large" formItemProps={{ label: "Officer" }} formWrapper={props.form} showSearch value={officerName} disabled={true}>
                  {officers.length === 0 && (
                    <Option key={""} value={""}>
                      Carregando...
                    </Option>
                  )}
                  {officers.map(officer => (
                    <Option key={`${officer.id.toString()}`} value={officerName}>
                      {officerName}
                    </Option>
                  ))}
                </PbrSelect>
              </Col>
            )}
          </Row> */}

          <Row gutter={16} className="actions-btn-row" style={{ marginTop: "60px" }}>
            <Col sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
              <StandardButton preset="outline" onClick={() => props.history.goBack()}>
                Voltar
              </StandardButton>
            </Col>
            <Col sm={24} md={12} lg={12} xl={12}>
              <StandardButton disabled={isEditDisallowed} htmlType="submit" loading={loading}>
                Salvar
              </StandardButton>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default withRouter(Form.create()(UserEdit));



// WEBPACK FOOTER //
// ./src/pages/manager/users/UserEdit.tsx